export const convertVitaminDToIU = (amountInMcg: number): number => amountInMcg * 40;

export const convertVitaminDToMcg = (amountInUI: number): number => amountInUI / 40;
